import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ItemChildrenActions } from './item-children.actions';
import { ItemChildrenSelectors } from './item-children.selectors';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {getActionQueries} from '@emm/core/util/ngrx.util';
import {ChildItemGrouping, ItemSummary} from '@emm/core/models/item-summary.model';


@Injectable({
    providedIn: 'root'
})
export class ItemChildrenStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>, private actions$: Actions) {
        super(store, ItemChildrenSelectors);
    }

    dispatch = {
        loadItemChildren: (path: string) =>
            this.store.dispatch(ItemChildrenActions.load({ path }))
    };

    queries = {
        ...this.asyncActionQueries,
        ...getActionQueries({
            actionCreators: ItemChildrenActions,
            actions$: this.actions$,
        }),
    };

    selectItemChildren(path: string): Observable<ItemSummary[]> {
        return this.store.pipe(
            select(ItemChildrenSelectors.getChildItems, { path }),
            map((grouping: ChildItemGrouping) => grouping && grouping.items)
        );
    }

}
